import React, { useCallback, useMemo } from 'react';
import { Chip, Grid } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { TagGrid } from 'components/styles_components/container';
import Date from 'components/date';

const FilterTags = ({ defaultValues, filterValues, onFilterChange }) => {
  const intlKey = useMemo(
    () => ({
      name: 'name',
      email: 'email',
      serialNumber: 'inspection_subject.serial_number',
      status: 'inspection.status',
      dueDateFrom: 'filter.due_date_from',
      dueDateTo: 'filter.due_date_to',
      doneAtFrom: 'filter.done_at_from',
      doneAtTo: 'filter.done_at_to',
      canceledAtFrom: 'filter.canceled_at_from',
      canceledAtTo: 'filter.canceled_at_to',
      inspectorId: 'filter.inspector',
      role: 'place.role',
    }),
    []
  );

  const valueParser = useMemo(
    () => ({
      name: (value) => value,
      role: (value) => <FormattedMessage id={`place.role.${value}`} />,
      email: (value) => value,
      serialNumber: (value) => value,
      status: (value) => <FormattedMessage id={`inspection.status.${value}`} />,
      dueDateFrom: (value) => <Date date={value} />,
      dueDateTo: (value) => <Date date={value} />,
      doneAtFrom: (value) => <Date date={value} />,
      doneAtTo: (value) => <Date date={value} />,
      canceledAtFrom: (value) => <Date date={value} />,
      canceledAtTo: (value) => <Date date={value} />,
      inspectorId: () => '',
    }),
    []
  );

  const deleteKey = useCallback(
    (key) => {
      const newFilterValues = { ...filterValues };
      newFilterValues[key] = defaultValues[key];
      onFilterChange(newFilterValues);
    },
    [filterValues, defaultValues, onFilterChange]
  );

  return (
    <TagGrid container spacing={2}>
      {Object.keys(filterValues).map((key, index) => {
        if (filterValues[key] === defaultValues[key]) {
          return null;
        }
        return (
          <Grid key={index}>
            <Chip
              label={
                <>
                  <FormattedMessage id={intlKey[key]} />{' '}
                  <b>{valueParser[key](filterValues[key])}</b>
                </>
              }
              onDelete={() => deleteKey(key)}
            />
          </Grid>
        );
      })}
    </TagGrid>
  );
};

export default React.memo(FilterTags);
